import React from 'react'
import {useNavigate} from "react-router-dom" 
import './Home.css'
import {FcNext} from 'react-icons/fc'
import Card1 from '../../assets/Yangiliklar/card1.png'
import Card2 from '../../assets/Yangiliklar/card2.png'
import Bcard1 from '../../assets/Yangiliklar/bcard1.png'
import Bcard2 from '../../assets/Yangiliklar/bcard2.png'
import Counter from './Counter/Counter'
import Slider from './Slider/Slider'
import TopImg from '../../assets/Yangiliklar/top1.png'
import BotImg from '../../assets/Yangiliklar/bottom1.png'
import photo from "../../assets/Photo"

const Home=()=> {
  const navigate=useNavigate();
  return (
    <div className='Home'>

     <Slider/>

      <div className='News'>
        <div className='News__info'>
          <div className='name'>
          <div className="line"></div>
          <p className='title'>Yangiliklar</p>
          </div>
          <div className='pass' onClick={()=>navigate('/yangiliklar')}>
            Barchasini ko'rish  <FcNext/>
          </div>
        </div>
          <div className='News__shows'>
            
          <div className='News__shows-top'>
           
            <div className='cardd'>
             <img src={TopImg} className='topimg' alt="" />
             <div className="card-title">
               <div className='inside'> Universitetimiz  Gong-Kong universiteti bilan aloqani yo’lga qo’ydi</div>
               </div>
           
            </div>
          
               <div className='rightt'>
              <div className='card2'>
                <img src={Card1} alt="" />
                <div className='infon'>
                <h4 className='titlee'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</h4>
                <div className="description">Vazirlar Mahkamasining «Oliy ta’lim muassasalari pedagog kadrlarini qayta tayyorlash va ularning...</div>
              </div> </div>
              <div className="card2">
               <img src={Card2} alt="" />
               <div className='infon'>
                <h4 className='titlee'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</h4>
                <div className="description">Vazirlar Mahkamasining «Oliy ta’lim muassasalari pedagog kadrlarini qayta tayyorlash va ularning...</div>
              </div>
              </div>
           </div>
          </div>
          <div className='News__shows-bottom '>
               <div className='left'>
               <div className='card3'>
                <img src={Bcard1} alt="card" />
                <div className='infon'>
                <h4 className='titlee'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</h4>
                <div className="description">Vazirlar Mahkamasining «Oliy ta’lim muassasalari pedagog kadrlarini qayta tayyorlash va ularning...</div>
              </div> </div>
              <div className="card3">
               <img src={Bcard2} alt="card" />
               <div className='infon'>
                <h4 className='titlee'>2022-yil Universitetimizda yangi fakultetlar ochilmoqda</h4>
                <div className="description">Vazirlar Mahkamasining «Oliy ta’lim muassasalari pedagog kadrlarini qayta tayyorlash va ularning...</div>
              </div></div> 
              </div>
              <div className='cardb'>
             <img src={BotImg} alt="" className='botimg'/>
             <div className="card-titlee">
               <div className='insidee'> Universitetimiz  Gong-Kong universiteti bilan aloqani yo’lga qo’ydi</div>
               </div>
            </div> 
          </div>
      
        </div>
      </div>

      <Counter/>

      <div className="Media">
      <div className='News__info'>
          <div className='name'>
          <div className="line"></div>
          <p className='title'>Media</p>
          </div>
          <div className='pass' onClick={()=>navigate("media/photo")}>
            Barchasini ko'rish  <FcNext/>
          </div>
        </div>
        <div className=' Media-wrapper'>
        <div className='Media__show'>
          {
            photo.slice(0,6).map((item,index)=>{
              return(
              <img src={item.imgurl} className='Media__show-image'  alt="Images" />
              )
            })
          }
         
         

        </div></div>

      </div>
       
       <div className='Menvid'>
          <iframe width="100%" height="700"  src="https://www.youtube.com/embed/Y-OLcnr8eNo" title="YouTube video player" frameborder="0" ></iframe>
        
       </div>
      

    </div>
  )
}
export default Home
